import { useQuery, useQueryClient } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';
import { refetchUserOnError } from 'utils/refetchUserOnError';

export type SubscriptionPlan = 'free' | 'standard' | 'premium' | 'enterprise';

export type SubscriptionBillingInterval = 'monthly' | 'yearly';

export type OrganizationSummary = {
  _id: string;
  name: string;
  plan?: SubscriptionPlan;
  subscriptionStartDate?: string;
  subscriptionEndDate?: string;
  subscriptionBillingInterval?: SubscriptionBillingInterval;
  membersCount: number;
  projectsCount: number;
  createdAt: string;
  updatedAt: string;
};

const getAllOrgs = async (): Promise<OrganizationSummary[]> => {
  const { data } = await customAxios.get<OrganizationSummary[]>('/organizations');
  return data;
};

export const useGetAllOrgs = (enabled = true) => {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: ['organizations'],
    queryFn: getAllOrgs,
    enabled,
    onError: (err) => {
      refetchUserOnError(err, queryClient);
    },
  });
};
